import { FC } from 'react';
import { Tooltip } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styles from './FreeTrialBadge.module.scss'
import useTrialDaysLeft from '../../../../../hooks/useTrialDaysLeft';

const FreeTrialBadge: FC = () => {
  const trialDaysLeft = useTrialDaysLeft();

  const navigate = useNavigate()

  const handleNavigatePayment = () => {
    navigate('/profile?tab=payment')
  }

  const getStatusClass = () => {
    if (trialDaysLeft > 14) return styles.success;
    if (trialDaysLeft > 7) return styles.warning;

    return styles.error;
  };

  const getColor = () => {
    if (trialDaysLeft > 14) return '#52c41a';
    if (trialDaysLeft > 7) return '#faad14';

    return '#ff4d4f';
  };

  const statusClass = getStatusClass();
  const color = getColor();

  const tooltipText = `${trialDaysLeft} day${trialDaysLeft === 1 ? '' : 's'} remaining in your free trial`;

  if (!trialDaysLeft) return null;

  return (
    <Tooltip
      title={
        <div style={{ textAlign: 'center' }}>
          {tooltipText}
        </div>
      }
      placement='bottom'
      overlayStyle={{ maxWidth: 270 }}
    >
      <div
        className={`${styles.freeTrialBadge} ${statusClass}`}
        style={{ color }}
        onClick={handleNavigatePayment}
      >
        <ClockCircleOutlined style={{ color }} />
        <span>Trial: </span>
        <span>{trialDaysLeft} Day{trialDaysLeft === 1 ? '' : 's'} Left</span>
      </div>
    </Tooltip>
  );
};

export default FreeTrialBadge;
